import { useState } from "react";
import { Loader2, Play, User, Mail } from "lucide-react";

export const QuizStartForm = ({ profile, onStart, busy }) => {
  const [name, setName] = useState(profile?.full_name || "");
  const submit = (e) => { e.preventDefault(); onStart({ full_name: name.trim() }); };

  return (
    <form onSubmit={submit} className="glass-card rounded-3xl p-6 md:p-10 max-w-xl" data-testid="quiz-start">
      <h2 className="font-display text-2xl text-white mb-6">Ready to start?</h2>
      <label className="block mb-4">
        <span className="text-xs uppercase tracking-[0.15em] text-white/45 mb-2 block">Your name (printed on the certificate)</span>
        <span className="flex items-center gap-3 rounded-xl bg-[#060B1E] border border-white/10 focus-within:border-[#4ECDC4] px-4 transition-colors">
          <User className="w-4 h-4 text-white/40" />
          <input required minLength={2} maxLength={100} value={name} onChange={(e) => setName(e.target.value)} data-testid="quiz-name-input"
            className="flex-1 bg-transparent py-3 text-white text-sm outline-none" placeholder="e.g. Priya Sharma" />
        </span>
      </label>
      <div className="mb-8">
        <span className="text-xs uppercase tracking-[0.15em] text-white/45 mb-2 block">Email (from your login)</span>
        <span className="flex items-center gap-3 rounded-xl bg-white/[0.03] border border-white/5 px-4 py-3 text-sm text-white/70" data-testid="quiz-email-display">
          <Mail className="w-4 h-4 text-white/40" /> {profile?.email}
        </span>
      </div>
      <button disabled={busy || name.trim().length < 2} data-testid="quiz-start-btn"
        className="btn-coral w-full px-10 py-4 rounded-full font-semibold text-base inline-flex items-center justify-center gap-2 disabled:opacity-60">
        {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Play className="w-5 h-5" />} Start the test
      </button>
      <p className="text-xs text-white/40 text-center mt-3">10 questions · 15 minutes</p>
    </form>
  );
};
